<template>
  <section class="physical-home-item-container" @click="handleToDetail(item)">
    <img class="product_img" :src="item.our_pic_url || item.mainPic" alt="">
    <div class="inner">
      <!-- 顶部 -->
      <div>
          <div class="title" :class="{'two-line': !item.coupon && !item.couponPrice}">
            <i class="store-logo" :class="[`icon_${item.source || 2}`]"></i>{{item.title}}
          </div>
          <div class="bubble_group" v-if="item.coupon || item.couponPrice">
            <div class="juan_box">
              <img class="juan_img" src="../imgs/icon_juan.png" alt="">
              <div class="box">¥{{item.coupon || (item.couponPrice).toFixed(2)}}</div>
            </div>
            <p class="stock">剩:<span>{{returnCouponNum(item)}}</span>/{{returnTotalNum(item)}}</p>
          </div>
      </div>
      <!-- 底部 -->
      <div>
        <div class="subtitle">
          <!-- 没有卷 -->
          <p class="price" v-if="!item.coupon && !item.couponPrice">单价:<i>¥</i>
            <span>
              <nr-amount :value="item.price" has-separator class="number" />
            </span>
          </p>

          <!-- 有卷 -->
          <p class="after-discount" v-else>
            券后:¥<span>
              <nr-amount :value="item.final_price || item.actualPrice" has-separator class="number" />
            </span>
          </p>

          <p class="sold" v-if="item.total_sold_num && item.total_sold_num > 0 ">已售:{{item.total_sold_num}}</p>
        </div>
        <div class="chat_bubble">
          <p class="left">
            佣金:<span>
              {{round ( (item.source === '2' || item.source === '4' ? item.channel_media_distribution_proportion : item.final_media_distribution_proportion) * 100|| item.channelCommissionRate)}}
            </span>%</p>
          <p class="right">约￥
            <!-- 预估佣金部分 -->
            <nr-amount :value="returnCommission(item) || item.actualPrice * item.channelCommissionRate * 0.01" has-separator class="number" />
          </p>
        </div>
      </div>
    </div>


  </section>
</template>

<script>
import { round } from "@/utils"
// 引入logo
import taobao_logo from "@/assets/imgs/icon_taobao.svg"
import jd_logo from "@/assets/imgs/icon_jd.svg"
import youzan_logo from "@/assets/imgs/icon_youzan.svg"
import pdd_logo from "@/assets/imgs/icon_pdd.svg"
export default {
  props: {
    item: {
      type: Object,
      default: {}
    },
    
    /*
    type/ 爆品
    标题 - title
    图片 - our_pic_url
    来源 - source
    单价 - price 
    已售 - total_sold_num
    优惠卷 - coupo
    优惠卷剩余量 - coupon_remain_count
    券后价 - final_price  
    分销比例 - item.channel_media_distribution_proportion || final_media_distribution_proportion
    分销佣金 - distribution_price
    */
    /*
    type/ 限时抢购
    单价 - price
    优惠卷 - couponPrice
    优惠卷总量 - couponTotalNum
    优惠卷已领取 - couponReceiveNum
    券后价 - actualPrice
    分销比例 - channelCommissionRate
    预估佣金 - 券后价 * 分销比例 *0.01
    */
    },
  data() {
    return {
      // 渠道
      sourceList: [
        0,// 占位
        youzan_logo, 
        taobao_logo, 
        jd_logo, 
        taobao_logo, 
        pdd_logo 
      ]
    }
  },
  methods: {
    round,
    // 去详情
    handleToDetail(item) {
      if (item.alias) {
        // 参数带有alias
        if(!this.isNewWindow) {
          this.$router.push({
            name: 'physicalDetail',
            params: {
              id: item.alias
            },
            query: {
              category: item.our_category_id
            }
          })
        }else{
          let { href } = this.$router.resolve({
            name: 'physicalDetail',
            params: {
              id: item.alias
            },
            query: {
              category: item.our_category_id
            }
          })
          let newWindow = window.open('_blank');
          newWindow.location = href
        }
        // 参数带有goodsId
      } else {
        if(!this.isNewWindow) {
          this.$router.push({
            name: 'physicalDetail',
            params: {
              id: `taobao${item.goodsId}`
            },
            query: {
              category: item.our_category_id
            }
          })
        }else{
          let { href } = this.$router.resolve({
            name: 'physicalDetail',
            params: {
              id: `taobao${item.goodsId}`
            },
            query: {
              category: item.our_category_id
            }
          })
          let newWindow = window.open('_blank');
          newWindow.location = href
        }        
      }
    },
    // 剩余券量
    returnCouponNum(item) {
      return item.coupon_remain_count&&this.returnW(item.coupon_remain_count) || item.couponReceiveNum&&this.returnW(item.couponTotalNum - item.couponReceiveNum) 
    },
    // 券总量
    returnTotalNum(item) {
      return item.couponTotalNum&&this.returnW(item.couponTotalNum) || item.coupon_total_count&&this.returnW(item.coupon_total_count)
    },
    // 预估佣金
    returnCommission(item) {
      if(item.source === '2' || item.source === '4') {
        return item.channel_media_distribution_proportion * item.final_price
      } else {
        return (item.is_activity_valid === '1' ? item.final_media_distribution_proportion : item.media_distribution_proportion) * item.final_price
      }
    },
    // 10000+变w显示
    returnW(item) {
      if (item.toString().length > 4) {
        return round(item / 10000) + 'w'
      } else {
        return item
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.physical-home-item-container{
  position: relative;
  z-index: 3;
  width: 290px;
  padding: 48px 16px 0;
  height: 540px;
  overflow: hidden;

  .product_img {
    width: 100%;
    height: 300px;
  }

  .inner {
    height: 220px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .two-line {
      white-space: unset !important;        
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
  }
  .title {
    margin-top: 16px;
    width: 272px;
    font-size: 28px;
    font-weight: 400;
    line-height: 42px;
    color: #3E4040;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    .store-logo{
      margin-right: 8px;
      display: inline-block;
      width: 28px;
      height: 28px;
      &.icon_1{
        background: url('../../../assets/imgs/icon_youzan.svg') no-repeat;
        background-size: cover;
      }
      &.icon_2,&.icon_4{
        background: url('../../../assets/imgs/icon_taobao.svg') no-repeat;
        background-size: cover;
      }
      &.icon_3{
        background: url('../../../assets/imgs/icon_jd.svg') no-repeat;
        background-size: cover;
      }
      &.icon_5{
        background: url('../../../assets/imgs/icon_pdd.svg') no-repeat;
        background-size: cover;
      }      
    }
  }
  .bubble_group {
    margin: 10px 12px 0 0;
    display: flex;
    justify-content: space-between;
    .juan_box {
      display: flex;
      align-items: center;
      .juan_img {
        width: 36px;
        height: 32px;
      }
      .box {
        padding-left: 5px;
        min-width: 40px;
        height: 32px;
        line-height: 1.8;
        padding-right: 10px;
        background: url('../imgs/icon_juan_box.png');
        background-size:100% 100%;
        font-size: 20px;
        font-weight: 400;
        color: #FF7733;
      }
    }
    .stock {
      font-size: 20px;
      font-weight: 400;
      line-height: 28px;
      color: #BABFBF;
      span {
        color: #FF7733;
      }
    }
  }
  .subtitle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .after-discount {
      font-size: 22px;
      font-weight: 400;
      line-height: 30px;
      color: #FF7733;
      span {
        font-size: 28px;
        font-weight: bold;
        line-height: 44px;
        color: #FF7733;
      }
    }
    .price {
      font-size: 22px;
      font-weight: 400;
      line-height: 30px;
      color: #BABFBF;
      i {
        color: #FF7733;
      }
      span {
        font-size: 28px;
        font-weight: bold;
        line-height: 44px;
        color: #FF7733;
      }
    }
    .sold {
      height: 30px;
      font-size: 22px;
      font-weight: 400;
      line-height: 30px;
      color: #BABFBF;
    }
  }
  .chat_bubble {
    box-sizing: border-box;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 50px;    
    margin-top: 16px;
    padding: 0 16px;
    background: #FF7733;
    border-radius: 8px;
    p {
      font-size: 22px;
      font-weight: 400;
      line-height: 30px;
      color: #FFFFFF;
    }
    .left {
      span {
        font-size: 28px;
        font-weight: bold;
        line-height: 44px;
        color: #FFFFFF;
      }
    }
    .right {
      opacity: 0.8;
    }
    &::after {
      content: '';
      position: absolute;
      width: 0;
      height: 0;
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
      border-bottom: 8px solid #FF7733;
      top: -5px;
      left: 32px;     
    }    
  }
}
</style>